import React from 'react';
import { Col, Row } from 'reactstrap';

import ScoreList from './scoreList';

class VisibleScoreList extends React.Component {
  constructor(props) {
    super(props);
    this.seeEveryoneScoreList = this.seeEveryoneScoreList.bind(this);
    this.seeFriendScoreList = this.seeFriendScoreList.bind(this);
  }

  seeFriendScoreList() {
    if (
      !this.props.friendTabIsVisible &&
      this.props.friendLeaderboard == null
    ) {
      this.props.updateFriendLeaderboard(false);
    }
    this.props.setFriendTabIsVisible(true);
  }

  seeEveryoneScoreList() {
    if (
      this.props.friendTabIsVisible &&
      this.props.everyoneLeaderboard == null
    ) {
      this.props.updateEveryoneLeaderboard(false);
    }
    this.props.setFriendTabIsVisible(false);
  }

  getRatingExamText = () => {
    const { user, possibleCyclesForUser } = this.props;

    if (user && user.id && possibleCyclesForUser.length > 0) {
      const ratingExam = user.ratingExam ? user.ratingExam : user.rank;
      const userInfo = `${ratingExam}`;
      return userInfo;
    }
    return '';
  };

  render() {
    if (this.props.friendTabIsVisible) {
      return (
        <div>
          <Row className="mt-3 header-text p-0 m-0">
            <Col className="p-0 m-0">
              <div
                onClick={this.seeFriendScoreList}
                className="text-center header-selected w-100 pb-2"
              >
                FRIENDS
              </div>
            </Col>
            <Col className="p-0 m-0">
              <div
                onClick={this.seeEveryoneScoreList}
                className="text-center pb-2"
              >
                {this.getRatingExamText()}
              </div>
            </Col>
          </Row>

          <ScoreList
            scoreList={this.props.friendLeaderboard}
            userId={this.props.user.id}
            loading={this.props.friendLeaderboardWaiting}
          />
        </div>
      );
    }
    return (
      <div>
        <Row className="mt-3 header-text p-0 m-0">
          <Col className="p-0 m-0">
            <div onClick={this.seeFriendScoreList} className="text-center pb-2">
              FRIENDS
            </div>
          </Col>
          <Col className="p-0 m-0">
            <div
              onClick={this.seeEveryoneScoreList}
              className="text-center header-selected pb-2"
            >
              {this.getRatingExamText()}
            </div>
          </Col>
        </Row>
        <ScoreList
          scoreList={this.props.everyoneLeaderboard}
          userId={this.props.user.id}
          loading={this.props.everyoneLeaderboardWaiting}
        />
      </div>
    );
  }
}
export default VisibleScoreList;
